import { FC } from 'react'
import { InvoicingAddressFormProvider } from 'components/forms/InvoicingAddress'
import { InvoicingAddressSectionController } from './InvoicingAddressSection.controller'
import { useTargetOrderUser } from '../../../_main/contexts'

/**
 * Root wrapper for the Invoicing Address section inside the purchase flow.
 *
 * Responsibilities:
 * - Provides InvoicingAddress form context to all nested components
 * - Renders the section controller that handles UI & logic
 *
 * This component is intentionally slim and only composes context + controller.
 */
export const InvoicingAddressSection: FC = () => {
  const { targetUser } = useTargetOrderUser()

  return (
    <InvoicingAddressFormProvider defaultValues={targetUser.country ? { country: targetUser.country } : undefined}>
      <InvoicingAddressSectionController />
    </InvoicingAddressFormProvider>
  )
}
